module.exports = __webpack_public_path__ + "img/WP2023-first-congress-1200-630.a6aac66c.png";